var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReceiveInvitation',{attrs:{"inviteCode":_vm.inviteCode,"errors":_vm.errors},on:{"accept":_vm.accept}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }